import { IProperty } from '@kaaja/data-models';
import { FacebookPixel } from '../FacebookPixel';
import { convertPropertyToEvent } from '../utils';

const sendPixelContact =
  (
    event:
      | 'Contatto_Chat'
      | 'Contatto_Telefono'
      | 'Form_Generico'
      | 'Iscrizione Newsletter'
  ) =>
  () => {
    FacebookPixel.trackCustom(event);
  };
const sendPixelContactPdp = (event: 'Form_PdP') => (property: IProperty) => {
  FacebookPixel.trackCustom(event, convertPropertyToEvent(property));
};

export const sendPixelChatContact = sendPixelContact('Contatto_Chat');
export const sendPixelPhoneContact = sendPixelContact('Contatto_Telefono');
export const sendPixelPdpFormContact = sendPixelContactPdp('Form_PdP');
export const sendPixelGenericFormContact = sendPixelContact('Form_Generico');
export const sendPixelNewsLetterSubscription = sendPixelContact(
  'Iscrizione Newsletter'
);
